export const MEDIA_TYPE_VIDEO = 'video'
export const MEDIA_TYPE_IMAGE = 'image'
export const MEDIA_TYPE_ANIMATION = 'animation'
